<template>
    <div>
        <div v-if="loading" class="container py-5 text-center">
            <div class="spinner-border" role="status"><span class="visually-hidden">Loading…</span></div>
        </div>
        <div v-else>
            <router-view v-slot="{ Component, route }">
                <component :is="Component" :mission="mission" @refresh="onSilentRefresh"
                    @transporteurUpdate="onTransporteurUpdate" @addPlate="onAddPlate" @removePlate="onRemovePlate"
                    @endDraft="onEndDraft" @next="goNext(route)" />
            </router-view>
        </div>
    </div>
</template>

<script>
import MissionService from '@/services/mission.service'
import MissionRepository from '@/repositories/mission.repo.js'

export default {
    name: 'MissionWizardLoader',
    data() {
        return {
            mission: null,
            loading: true,
            error: ''
        };
    },
    mounted() {
        this.fetchMission();
    },
    watch: {
        '$route.params.id'() { this.fetchMission(); }
    },
    methods: {
        onSilentRefresh() {
            this.fetchMission(true);
        },
        async fetchMission(silent = false) {
            const id = this.$route.params.id;
            if (!id) return;
            try {
                if (!silent) this.loading = true;
                this.mission = await MissionRepository.getMission(id);
            } catch (e) {
                this.error = e?.response?.data?.message || e.message || 'Erreur de chargement.';
                alert(this.error);
            } finally {
                if (!silent) this.loading = false;
            }
        },
        async onTransporteurUpdate(baliseId) {
            if (!this.mission?.id) return;
            // 🔒 Garde-fou anti-boucle: ne rien faire si la valeur n'a pas changé
            if (String(baliseId) === String(this.mission.transporteurId)) return;
            try {
                await MissionService.transporteurUpdate(this.mission.id, { transporteurId: baliseId });
                await this.fetchMission(true);
            } catch (e) {
                alert(e?.response?.data?.message || e.message || 'Erreur lors de la sélection du véhicule.');
            }
        },
        async onAddPlate(immat) {
            if (!this.mission?.id) return;
            try {
                await MissionService.addMissionPlate(this.mission.id, immat);
                await this.fetchMission(true);
            } catch (e) {
                alert(e?.response?.data?.message || e.message || 'Erreur ajout de plaque.');
            }
        },
        async onRemovePlate(plateId) {
            if (!this.mission?.id) return;
            try {
                await MissionService.removeMissionPlate(this.mission.id, plateId);
                await this.fetchMission(true);
            } catch (e) {
                alert(e?.response?.data?.message || e.message || 'Erreur suppression de plaque.');
            }
        },
        async onEndDraft() {
            if (!this.mission?.id) return;
            try {
                await MissionService.endDraft(this.mission.id);
                this.$router.replace({ name: 'MissionInfo', params: { id: this.mission.id } });
            } catch (e) {
                alert(e?.response?.data?.message || e.message || 'Erreur de fin de brouillon.');
            }
        },
        goNext(route) {
            // Navigation “prochaine étape” basée sur le name courant
            const NEXT = {
                MissionWizardName: 'MissionWizardTransporteur',
                MissionWizardTransporteur: 'MissionWizardDrivers',
                MissionWizardDrivers: 'MissionWizardConvoy',
                MissionWizardConvoy: 'MissionWizardPlates'
            };
            const nextName = NEXT[route?.name] || null;
            if (!nextName) return;
            this.$router.push({ name: nextName, params: { id: this.$route.params.id } });
        }
    }
}
</script>
